import '@nectary/assets/icons-branded/chat'
import '@nectary/assets/icons-branded/push'
import '@nectary/assets/icons-branded/rcs'
import '@nectary/assets/icons-branded/settings'
import '@nectary/assets/icons-channel/apple-business-chat'
import '@nectary/assets/icons-channel/apple-business-chat-square'
import '@nectary/assets/icons-channel/facebook-messenger'
import '@nectary/assets/icons-channel/facebook-messenger-square'
import '@nectary/assets/icons-channel/instagram'
import '@nectary/assets/icons-channel/instagram-square'
import '@nectary/assets/icons-channel/line'
import '@nectary/assets/icons-channel/line-square'
import '@nectary/assets/icons-channel/telegram'
import '@nectary/assets/icons-channel/telegram-square'
import '@nectary/assets/icons-channel/viber'
import '@nectary/assets/icons-channel/viber-square'
import '@nectary/assets/icons-channel/webchat-square'
import '@nectary/assets/icons-channel/whatsapp'
import '@nectary/assets/icons-channel/whatsapp-square'
import { setAssetsRegistry } from '@nectary/assets/utils'
import '@nectary/components/action-menu'
import '@nectary/components/action-menu-option'
import '@nectary/components/badge'
import '@nectary/components/button'
import '@nectary/components/checkbox'
import '@nectary/components/chip'
import '@nectary/components/dialog'
import '@nectary/components/field'
import '@nectary/components/help-tooltip'
import '@nectary/components/inline-alert'
import '@nectary/components/input'
import '@nectary/components/link'
import '@nectary/components/pagination'
import '@nectary/components/popover'
import '@nectary/components/radio'
import '@nectary/components/radio-option'
import '@nectary/components/segment-collapse'
import '@nectary/components/select-button'
import '@nectary/components/select-menu'
import '@nectary/components/select-menu-option'
import '@nectary/components/skeleton'
import '@nectary/components/skeleton-item'
import '@nectary/components/spinner'
import '@nectary/components/table'
import '@nectary/components/table-body'
import '@nectary/components/table-cell'
import '@nectary/components/table-head'
import '@nectary/components/table-head-cell'
import '@nectary/components/table-row'
import '@nectary/components/tag'
import '@nectary/components/text'
import '@nectary/components/textarea'
import '@nectary/components/title'
import '@nectary/components/toggle'
import { setNectaryRegistry } from '@nectary/components/utils'
import '@nectary/theme-message-media'

/**
 * Classes for nectary themes based on the platform.
 */
export const themes = Object.freeze({
  engage: 'nectary-theme-base',
  mm: 'nectary-theme-base nectary-theme-message-media',
})

/**
 * Set nectary and nectary-assets custom element registries.
 * If already set, it is noop.
 *
 * @param registry The custom element registry.
 */
export const setNectaryRegistries = (registry: CustomElementRegistry) => {
  try {
    setNectaryRegistry(registry)
    setAssetsRegistry(registry)
  } catch {
    /* empty */
  }
}
